export enum QualificationStatuses {
	NOT_MET = "0NM",
	MET_MAIN = "5MI",
	MET_VIP_1 = "4V1",
	MET_VIP_2 = "3V2",
	MET_NQ = "6MNQ",
	MET_GR = "2MGR",
	MET_INVT = "1MST"
}